import { footerCates } from "../../../mocks/portalData";

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.3fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-sm font-black text-background-50">
                52
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">黑料 · 合集分类图鉴</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              以分类图鉴手册的方式，把全网热门事件、人物与类型按索引归档整理，并汇总网友热评讨论。
              想快速吃透一个瓜，翻这本手册就够了。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2 text-sm text-foreground-600">
              <span className="flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-800">
                <i className="ri-time-line"></i> 热榜每小时刷新
              </span>
              <span className="flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-800">
                <i className="ri-archive-line"></i> 图鉴持续归档
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-black text-foreground-950">分类目录</h4>
            <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {footerCates.map((c) => (
                <a key={c.label} href="#catalog" className="group flex items-center justify-between text-sm text-foreground-600 hover:text-foreground-950">
                  <span className="whitespace-nowrap">{c.label}</span>
                  <span className="text-xs text-foreground-400">{c.count}</span>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-black text-foreground-950">快速入口</h4>
            <div className="mt-4 grid gap-2.5">
              {[
                { label: "全网热榜", key: "#hot" },
                { label: "分类图鉴", key: "#catalog" },
                { label: "事件时间线", key: "#timeline" },
                { label: "热议现场", key: "#flow" },
                { label: "热评讨论区", key: "#comments" },
              ].map((link) => (
                <a key={link.key} href={link.key} className="flex items-center gap-2 text-sm text-foreground-600 hover:text-foreground-950">
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-200 pt-5 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 52黑料合集分类图鉴手册 · 仅供娱乐内容梳理与讨论，请理性看待网络信息。</p>
          <p className="flex items-center gap-1 whitespace-nowrap">
            内容仅作汇总展示，不代表本站立场
            <i className="ri-shield-check-line"></i>
          </p>
        </div>
      </div>
    </footer>
  );
}